var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"$ticketCountCtrl.ticketCount\" class=\"alert alert-info\">You have selected <strong>{{$ticketCountCtrl.ticketCount}} ticket<span ng-if=\"$ticketCountCtrl.ticketCount > 1\">s</span></strong>. Please review the details below and click \"{{$ticketCountCtrl.continueText}}\".</div>";
var id1="javascripts/basket/ticket_count/ticket_count.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/basket/ticket_count/ticket_count.template.html
// module id = 1295
// module chunks = 0